(() => {
  if (window.__broomGlowSaleEnhancementsLoaded) return;
  window.__broomGlowSaleEnhancementsLoaded = true;

  const PRODUCT_ID = '15750470205780';
  const offers = [
    { quantity: 1, total: '54.99 PLN', each: '54.99 PLN', badge: '', saving: '' },
    { quantity: 2, total: '98.98 PLN', each: '49.49 PLN', badge: 'POPULAR', saving: 'SAVE 10% · 11.00 PLN' },
    { quantity: 3, total: '140.22 PLN', each: '46.74 PLN', badge: 'BEST VALUE', saving: 'SAVE 15% · 24.75 PLN' },
  ];

  const escapeHtml = (value) =>
    String(value).replace(/[&<>'"]/g, (character) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      "'": '&#039;',
      '"': '&quot;',
    })[character]);

  function initAnnouncementTicker() {
    const text = document.querySelector('.announcement-bar__text');
    if (!text || text.dataset.broomglowTicker === 'true') return;

    const message = text.textContent.trim();
    if (!message) return;

    text.dataset.broomglowTicker = 'true';
    text.classList.add('broomglow-sale-ticker');
    text.setAttribute('aria-label', message);

    const item = `<span class="broomglow-sale-ticker__item">${escapeHtml(message)}</span>`;
    const group = `<span class="broomglow-sale-ticker__group">${item.repeat(4)}</span>`;
    text.innerHTML = `<span class="broomglow-sale-ticker__track" aria-hidden="true">${group}${group}</span>`;

    const slides = text.closest('.announcement-bar__slides');
    if (slides) slides.classList.add('broomglow-sale-ticker-host');
  }

  function bundleMarkup() {
    const cards = offers.map((offer) => {
      const noun = offer.quantity === 1 ? 'Broom' : 'Brooms';
      const badge = offer.badge ? `<span class="broomglow-bundle-card__badge">${offer.badge}</span>` : '';
      const saving = offer.saving ? `<span class="broomglow-bundle-card__saving">${offer.saving}</span>` : '<span class="broomglow-bundle-card__saving">REGULAR PRICE</span>';

      return `
        <button
          type="button"
          class="broomglow-bundle-card${offer.quantity === 1 ? ' is-selected' : ''}"
          data-broomglow-quantity="${offer.quantity}"
          aria-pressed="${offer.quantity === 1 ? 'true' : 'false'}"
        >
          ${badge}
          <span class="broomglow-bundle-card__quantity">${offer.quantity} ${noun}</span>
          <span class="broomglow-bundle-card__price">${offer.total}</span>
          <span class="broomglow-bundle-card__each">${offer.each} each</span>
          ${saving}
        </button>`;
    }).join('');

    return `
      <div class="broomglow-bundle-offer" data-broomglow-bundle-offer>
        <div class="broomglow-bundle-offer__heading-row">
          <strong class="broomglow-bundle-offer__heading">BUNDLE &amp; SAVE</strong>
          <span class="broomglow-bundle-offer__auto">Discount applied automatically</span>
        </div>
        <div class="broomglow-bundle-grid" role="group" aria-label="Choose bundle size">
          ${cards}
        </div>
      </div>`;
  }

  function setQuantity(block, quantity) {
    let quantityInputs = Array.from(block.querySelectorAll('input[name="quantity"]'));

    if (quantityInputs.length === 0) {
      const form = block.querySelector('form[data-type="add-to-cart-form"], form[action*="/cart/add"]');
      if (form) {
        const hiddenQuantity = document.createElement('input');
        hiddenQuantity.type = 'hidden';
        hiddenQuantity.name = 'quantity';
        form.appendChild(hiddenQuantity);
        quantityInputs = [hiddenQuantity];
      }
    }

    quantityInputs.forEach((input) => {
      input.value = String(quantity);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    block.querySelectorAll('[data-broomglow-quantity]').forEach((card) => {
      const selected = Number(card.dataset.broomglowQuantity) === quantity;
      card.classList.toggle('is-selected', selected);
      card.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
  }

  function initBundleOffers() {
    document.querySelectorAll('main#MainContent .buy-buttons-block').forEach((block) => {
      if (block.querySelector('[data-broomglow-bundle-offer]')) return;

      const productForm = block.querySelector('product-form-component');
      const formButtons = block.querySelector('.product-form-buttons');
      if (!productForm || !formButtons) return;

      const productId = String(productForm.dataset.productId || '');
      if (productId !== PRODUCT_ID) return;

      formButtons.insertAdjacentHTML('afterbegin', bundleMarkup());
    });
  }

  function syncBundleFromQuantity(event) {
    const input = event.target.closest?.('input[name="quantity"]');
    if (!input) return;

    const block = input.closest('.buy-buttons-block');
    if (!block || !block.querySelector('[data-broomglow-bundle-offer]')) return;

    const quantity = Number(input.value);
    if (![1, 2, 3].includes(quantity)) return;

    block.querySelectorAll('[data-broomglow-quantity]').forEach((card) => {
      const selected = Number(card.dataset.broomglowQuantity) === quantity;
      card.classList.toggle('is-selected', selected);
      card.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
  }

  document.addEventListener('click', (event) => {
    const card = event.target.closest?.('[data-broomglow-quantity]');
    if (!card) return;

    const block = card.closest('.buy-buttons-block');
    if (!block) return;

    setQuantity(block, Number(card.dataset.broomglowQuantity));
  });

  document.addEventListener('input', syncBundleFromQuantity);
  document.addEventListener('change', syncBundleFromQuantity);

  const init = () => {
    initAnnouncementTicker();
    initBundleOffers();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      init();
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
